"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const model_1 = __importDefault(require("../base/model"));
const lines_schema_1 = require("./lines.schema");
class Lines extends model_1.default {
    isKeyAllowed(key) {
        if (key == 'languageCodes')
            return false;
        if (key == 'facia')
            return false;
        if (key == 'botEnabled')
            return false;
        if (key == 'greetingMessageARN')
            return false;
        if (key == 'group')
            return false;
        if (key == 'orderLookupEnabled')
            return false;
        if (key == 'queueLimit')
            return false;
        if (key == 'hidePlugins')
            return false;
        if (key == 'showPlugins')
            return false;
        if (key == 'company')
            return false;
        if (key == 'created')
            return false;
        if (key == 'updated')
            return false;
        return true;
    }
}
exports.default = Lines;
Lines.schema = lines_schema_1.LinesSchema;
